/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { useCategories } from '@hooks/useCategories'
import { DisplayTypeEnum } from '@interfaces/DisplayTypeEnum'
import { BookEnum } from '@interfaces/BookEnum'
import { usePenNameAction } from '@hooks/penName/usePenNameAction'
import {
  CampaignSearchFormProps,
  WithCampaignSearchFormProps,
} from './interface'

const displayType = [
  { value: DisplayTypeEnum.WEB, label: 'เว็บ' },
  { value: DisplayTypeEnum.ANDROID, label: 'android' },
  { value: DisplayTypeEnum.IOS, label: 'ios' },
]

const bookType = [
  { value: BookEnum.NOVEL, label: 'นิยาย' },
  { value: BookEnum.MANGA, label: 'การ์ตูน' },
]

export function withCampaignSearchForm(
  Component: React.FC<CampaignSearchFormProps>
) {
  function WithCampaignSearchForm({
    campaignId,
    initialValues,
    handleSubmit,
  }: WithCampaignSearchFormProps) {
    const router = useRouter()
    const penNameClient = usePenNameAction()

    const { data: penNameOptions = [] } = useQuery(
      ['pen-name-options', campaignId],
      () =>
        penNameClient.getPennamesByBanner(Number(campaignId)).then(res =>
          res.map((row: any) => ({
            ...row,
            value: String(row.value),
          }))
        ),
      { enabled: !!campaignId }
    )

    const { categories } = useCategories()
    const [showAdvanceSearch, setShowAdvanceSearch] = useState<boolean>(
      router.query.advanceSearch === 'true'
    )

    function handleAdvanceSearchChange() {
      setShowAdvanceSearch((prev: boolean) => !prev)

      router.replace({
        pathname: router.pathname,
        query: {
          campaignId,
          text: initialValues.searchText,
          advanceSearch: !showAdvanceSearch,
        },
      })
    }

    const pageProps = {
      initialValues,
      displayType,
      bookType,
      categories,
      penNameOptions,
      showAdvanceSearch,
      handleAdvanceSearchChange,
      handleSubmit,
    }
    return <Component {...pageProps} />
  }

  return WithCampaignSearchForm
}
